import {
    StyleSheet
} from "react-native";
import type {
    ImageStyle
} from "react-native";
import {
    webStyle
} from "ncore-ui-kit";

const stylesheet = StyleSheet.create({
    contentContainer: {
        alignItems: "center",
        display: "flex",
        width: "100%",
        flex: 1
    },
    container: {
        justifyContent: "space-between",
        alignItems: "center"
    },
    orlineContainer: {
        flexDirection: "row"
    },
    line: {
        height: 1,
        flex: 1
    },
    logo: {
        width: 200,
        ...webStyle({
            height: 150
        })
    } as ImageStyle
});
export default stylesheet;
